import { IFrequencyFormatHelperService } from '../services';
import { IFrequency } from '../models';

export const filterId = 'wtFrequency';

export const factory = ['frequencyFormatHelperService', (_service: IFrequencyFormatHelperService) => {
    return (value: IFrequency) => {
        return value ? _service.formatFrequency(value) : '';
    };
}];